<div [formGroup]="dbsAmexEligibilityForm">
  <input
    class="inputbox"
    type="text"
    formControlName="indentifier"
    [placeholder]="(customVariables$ | async)?.eligibility_identifier"
  />
  <mat-error
    ngxErrors="indentifier"
    ngxError="required"
    when="touched"
    [translate]="'JadeEligibilityCheck:MustBeValid'"
    role="alert"
  >
  </mat-error>

  <input
    class="inputbox"
    type="password"
    formControlName="indentifier2"
    [placeholder]="(customVariables$ | async)?.eligibility_second_identifier"
  />
  <mat-error
    ngxErrors="indentifier2"
    [ngxError]="['minlength', 'maxlength', 'required', 'pattern']"
    when="touched"
    [translate]="'JadeEligibilityCheck:MustBeValid'"
    role="alert"
  >
  </mat-error>
</div>
